import Fetch from './fetch';
import isEdgeIE from './detectEdgeIE';
import isIOS from './isIos';

const DownloadFromUrlEdgeIE = fileURL => new Promise(async (resolve, reject) => {
  let fileName;
  Fetch.Get(fileURL)
    .then((response) => {
      fileName = String(response.headers.get('content-disposition').split(';', 2)[1].slice(response.headers.get('content-disposition').split(';', 2)[1].indexOf("=") + 1).replaceAll("\"", ""));

      return response.blob();
    })
    .then((blob) => {
      window.navigator.msSaveBlob(blob, fileName);
    })
    .then(() => resolve())
    .catch((err) => {
      reject(err);
    })
    .finally(() => { document.body.style.cursor = 'default'; });
});

const OpenFileInIOS = (fileURL, readerWindow) => new Promise(async (resolve, reject) => {
  let contentType;
  Fetch.Get(fileURL)
    .then((response) => {
      contentType = String(decodeURIComponent(response.headers.get('content-type')));
      return response.blob();
    })
    .then((blob) => {
      const reader = new FileReader();
      const out = new Blob([blob], { type: contentType });
      reader.onload = () => {
        readerWindow.location.href = reader.result; //eslint-disable-line
        readerWindow.focus();
      };
      reader.readAsDataURL(out);
      resolve();
    })
    .catch(err => reject(err))
    .finally(() => { document.body.style.cursor = 'default'; });
});

// eslint-disable-next-line consistent-return
const DownloadFromUrl = fileURL => new Promise(async (resolve, reject) => {
  document.body.style.cursor = 'progress';
  const a = document.createElement('a');

  if (isEdgeIE()) {
    try {
      await DownloadFromUrlEdgeIE(fileURL);
    } catch (err) {
      return reject(err);
    }
    return resolve();
  }

  if (isIOS()) {
    const readerWindow = window.open('', '_blank');
    readerWindow.document.write('<h1 style="color:#fc3650;">Loading...</h1>');
    try {
      await OpenFileInIOS(fileURL, readerWindow);
    } catch (err) {
      return reject(err);
    }
    return resolve();
  }

  let fileName;
  Fetch.Get(fileURL)
    .then((response) => {
      fileName = String(response.headers.get('content-disposition').split(';', 2)[1].slice(response.headers.get('content-disposition').split(';', 2)[1].indexOf("=") + 1).replaceAll("\"", ""));

      return response.blob();
    })
    .then(blob => window.URL.createObjectURL(blob))
    .then((url) => {
      a.href = url;
      if (fileName) {
        a.download = fileName;
      }
      a.click();
    })
    .then(() => resolve())
    .catch((err) => {
      reject(err);
    })
    .finally(() => { document.body.style.cursor = 'default'; });
});



export default DownloadFromUrl;



// WEBPACK FOOTER //
// ./src/helpers/download.js